<template>
  <div>
    <canvas ref="signatureCanvas" class="kiosk-signature"></canvas>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'

export default {
  name: 'KioskSignaturePad',
  data () {
    return {
      pad: null,
      resizeObserver: null
    }
  },
  methods: {
    clear () {
      if (this.pad) {
        this.pad.clear()
        this.$emit('input', '')
      }
    },
    resizeCanvas () {
      const canvas = this.$refs.signatureCanvas
      if (!canvas || !canvas.offsetWidth || !canvas.offsetHeight) {
        return
      }
      const ratio = Math.max(window.devicePixelRatio || 1, 1)
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      canvas.getContext('2d').scale(ratio, ratio)
      if (this.pad) {
        this.pad.clear()
        this.$emit('input', '')
      }
    }
  },
  mounted () {
    const canvas = this.$refs.signatureCanvas
    this.pad = new SignaturePad(canvas)
    this.pad.addEventListener('endStroke', () => {
      this.$emit('input', this.pad.toDataURL())
    })
    this.resizeCanvas()
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => this.resizeCanvas())
      this.resizeObserver.observe(canvas)
    } else {
      window.addEventListener('resize', this.resizeCanvas)
    }
  },
  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.resizeCanvas)
    }
  }
}
</script>

<style scoped>
.kiosk-signature {
  background: #FFEDB2;
  border: 1px dashed var(--form-color);
  border-radius: 14px;
  height: 280px;
  width: 100%;
}
@media screen and (max-width: 768px) {
  .kiosk-signature {
    height: 220px;
  }
}
</style>
